import logo from './logo.svg';
import './App.css';
import Test from './componentes/Test';
import { Button, HeroUIProvider, Switch } from '@heroui/react';
import AppRouter from './componentes/Router/AppRouter';
import StoreProvider from './componentes/Store/StoreProvider';
import AuthProvider from './componentes/ProviderAuth/AuthProvider';

function App() {
  return (
    <div className=''>
      <HeroUIProvider>
          <AppRouter/>
      </HeroUIProvider>
    </div>
  );
}

export default App;
